<template>
  <div v-if="Committees" id="members" class="module">
    <h1>Your Company Committees</h1>

    <el-row :gutter="28">
      <el-col v-for="(Committee, index) in Committees" :key="index" :span="8">
        <el-card class="box-card flexbox flexbox__end">
          <img
            :src="
              `https://sustainablepackaging.org/${Committee.Image[0].url_tail}`
            "
            :alt="Committee.name"
            width="75px"
          />
          <div class="title">{{ Committee.name }}</div>
          <!-- <p class="text" v-html="$options.filters.truncate(Committee.intro, 100)"></p>&hellip; -->
          <p
            class="text"
            v-html="$options.filters.truncate(Committee.intro, 100)"
          ></p>
          <el-button type="primary">Read more</el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import _ from "lodash";
import ApolloCommittees from "@/graphql/Company/Committees.gql";

export default {
  name: "Committees",
  apollo: {
    Committees: {
      query: ApolloCommittees,
      variables() {
        return {
          companyName: this.$store.state.company.name
        };
      },
      update(data) {
        return !_.isEmpty(data.Company[0].Committees)
          ? data.Company[0].Committees
          : false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  height: 375px;
  margin-bottom: 1.75rem;
}

img {
  margin-bottom: 1.5rem;
}

.title {
  font-weight: 700;
  font-size: 16px;
  color: #2bd8b6;
  letter-spacing: 0;
  line-height: 23px;
}

.text {
  font-weight: 500;
  font-size: 16px;
  color: #8a8a8a;
  letter-spacing: 0;
  line-height: 23px;
}
</style>
